import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import "./billing.css";
import BillingData from "./invoiceForm";
import BillingShowData from "./invoiceDetails";
import { FaInfo } from "react-icons/fa";
import Swal from "sweetalert2";
import axios from "axios";
import { Modal, Spinner } from "react-bootstrap";

// --- Funciones de Utilidad (Clean Code: fuera del componente para no re-declararlas) ---
const addCommas = (num) => {
  if (num === null || num === undefined) return "";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const formatDate = (dateString) => {
  const d = new Date(dateString);
  if (isNaN(d)) return "-";
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  const hours = String(d.getUTCHours()).padStart(2, '0');
  const minutes = String(d.getUTCMinutes()).padStart(2, '0');
  const seconds = String(d.getUTCSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

function BillingSearch({ onSearchSuccess }) {
  // --- Estados de Lógica ---
  const [masterValueData, setMasterValueData] = useState("");
  const [error, setError] = useState("");
  const [isPedimentoChecked, setIsPedimentoChecked] = useState(false);
  const [selectedHouses, setSelectedHouses] = useState({});
  const [facturarError, setFacturarError] = useState(false);

  // --- Estados de Datos ---
  const [billingFormData, setBillingFormData] = useState(null);
  const [pastInvoices, setPastInvoices] = useState([]);
  const [houses, setHouses] = useState([]);

  // --- Estados de Vistas (Tu flujo original) ---
  const [showBillingForm, setShowBillingForm] = useState(false);
  const [showBillingShowData, setShowBillingData] = useState(false);
  const [showPartialTable, setShowPartialTable] = useState(false);
  const [showPartialHouseTable, setShowPartialHouseTable] = useState(false);
  const [viewBillingData, setViewBillingData] = useState("input");

  const [loading, setLoading] = useState(false);

  // Efecto para popup de pedimento (Mantiene tu lógica original)
  useEffect(() => {
    const checkPedimento = async () => {
      const trimmed = masterValueData.trim();
      if (isPedimentoChecked && /^\d{3}-\d+$/.test(trimmed)) {
        // Simulación de validación de houses con pedimento
        const requiere = ["123-44447777", "139-05050505", "123-44448888", "123-12341234", "139-46864694"].includes(trimmed);
        if (requiere) showPedimentoPopup();
      }
    };
    checkPedimento();
  }, [isPedimentoChecked]);

  const handleInputChangeBilling = (e) => {
    let value = e.target.value;

    value = value.replace(/\D/g, "");

    if (value.length > 11) {
      value = value.slice(0, 11);
    }

    if (value.length > 3) {
      value = value.slice(0, 3) + "-" + value.slice(3);
    }

    setMasterValueData(value);
    if (error) setError("");
  };

  const handleSearch = async () => {
    const pattern = /^\d{3}-\d+$/;
    const trimmedValue = masterValueData.trim();

    // Reset de estados visuales
    setError("");
    setFacturarError(false);
    setShowBillingForm(false);
    setShowPartialTable(false);
    setShowPartialHouseTable(false);

    if (!trimmedValue) return setError("Debe ingresar una guía");
    if (!pattern.test(trimmedValue)) return setError("Ingrese la guía correctamente");
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/expo_invoices/get_houses`,
        { awb: trimmedValue, pediment: isPedimentoChecked },
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("token") || ""}` } }
      );

      const { body } = response.data;

      if (body[0] === 0) {
        setLoading(false);
        setError("Error, la master no existe");
      } else if (body[0] === 1) {
        if (body[2] === -1) {
          // Facturación directa (Master)
          await submit({ awb: trimmedValue, pediment: isPedimentoChecked }, body[1]);
        } else {
          // Master con historial
          setLoading(false);
          setPastInvoices(body[2]);
          setShowPartialTable(true);
        }
      } else {
        // Guía con Houses
        setLoading(false);
        setPastInvoices(body[2]);
        setHouses(Array.isArray(body[1]) ? body[1] : [body[1]]);
        setShowPartialHouseTable(true);
        if (body[2].length > 0) {
          setLoading(false);
          setShowPartialTable(true);
        }
      }
    } catch (err) {
      setLoading(false);
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
    }
  };

  const submit = async (data, invoice_id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/expo_invoices/form`,
        { awb: data.awb, pediment: data.pediment ? 1 : null, invoice_id },
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("token") || ""}` } }
      );
      if (response.data.error) {
        setLoading(false);
        return Swal.fire("Error", response.data.body, "error");
      }
      setLoading(false);
      
     
      onSearchSuccess({
        view: "billing", 
        masterNumber: masterValueData,
        formData: response.data 
      });
    } catch (err) {
      setLoading(false);
      Swal.fire("Error", "Hubo un error al procesar la solicitud", "error");
    }
  };

  const handleShowInvoiceDetails = async (invoiceId) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/expo_invoices/form`,
        { id_invoice: invoiceId },
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } }
      );
      if (response.data.error) {
        setLoading(false);
        return Swal.fire("Error", response.data.error, "error");
      }
      onSearchSuccess({
        view: "showDetails", 
        masterNumber: masterValueData,
        formData: response.data 
      });
      
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Swal.fire("Error", "No se pudo obtener la información de la factura", "error");
    }
  };

  const handleCheckboxChange = (index) => {
    setSelectedHouses(prev => ({ ...prev, [index]: !prev[index] }));
    setFacturarError(false);
  };

  const handleFacturar = () => {
    if (!Object.values(selectedHouses).some(val => val)) {
      setFacturarError(true);
    } else {
      setShowBillingForm(true);
    }
  };

  const showPedimentoPopup = () => {
    Swal.fire({
      title: "Datos de la guía",
      html: `
      <div class="container-fluid swal-custom-content">
        <div class="row mb-3 text-start">
          <div class="col-md-4 mb-4"><label><strong>AWB:</strong> ${masterValueData}</label></div>
          <div class="col-md-4 mb-4"><label><strong>Piezas totales:</strong> -</label></div>
          <div class="col-md-4 mb-4"><label><strong>Peso total:</strong> -</label></div>
        </div>
        <div class="row mb-2 text-start">
          <div class="col-md-4 mb-2"><div class="form-group"><label>Piezas *</label><input type="text" class="form-control" id="factura" /></div></div>
          <div class="col-md-4 mb-2"><div class="form-group"><label>Peso *</label><input type="number" class="form-control" id="monto" /></div></div>
          <div class="col-md-4 mb-2"><div class="form-group"><label>No Pedimento *</label><input type="text" class="form-control" id="comentarios" /></div></div>
        </div>
      </div>`,
      showCancelButton: true,
      confirmButtonText: "Facturar",
      customClass: { popup: "swal-wide alert-bg", title: "alert-title", confirmButton: "btn-amc-blue", cancelButton: "btn-amc-pink" },
      preConfirm: () => ({
        factura: document.getElementById("factura").value,
        monto: document.getElementById("monto").value,
        comentarios: document.getElementById("comentarios").value
      }),
    }).then((result) => {
      setIsPedimentoChecked(false);
      if (result.isConfirmed) Swal.fire("¡Facturado!", "La guía fue procesada.", "success");
    });
  };

  return (
    <>
      <div className="container-fluid">
        {viewBillingData === "input" && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label htmlFor="inputMaster" className="amc-label">Master</label>
              <input type="text" className="form-control" id="inputMaster" value={masterValueData} onChange={handleInputChangeBilling} />

              <div className="row mt-3">
                <div className="col-12">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="gridCheck" checked={isPedimentoChecked} onChange={(e) => setIsPedimentoChecked(e.target.checked)} />
                    <label className="form-check-label" htmlFor="gridCheck">Pedimento</label>
                  </div>
                </div>
              </div>
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleSearch}>Buscar</button>
              </div>

              {error && <div className="text-danger mt-2 alert alert-danger text-center">{error}</div>}
            </div>

            {(showPartialHouseTable || showPartialTable) && (
              <div className="row mt-4">
                <div className="col-12">
                  {showPartialHouseTable && (
                    <>
                      <table className="table text-center mx-auto" style={{ maxWidth: "900px", width: "100%" }}>
                        <thead className="table fondo-head">
                          <tr>
                            <th>HBS</th><th>Fecha</th><th>Piezas</th><th>Peso</th><th>Piezas restantes</th><th>Peso restantes</th><th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {houses.map((house, index) => (
                            <tr key={index}>
                              <td>{house.hbs}</td><td>{house.date}</td>
                              <td>{addCommas(house.pieces || house.hpieces)}</td>
                              <td>{addCommas(house.weight || house.hweight)}</td>
                              <td>{addCommas(house.hrpieces)}</td>
                              <td>{addCommas(house.hrweight)}</td>
                              <td>
                                {pastInvoices.length === 0 && (
                                  <input type="checkbox" checked={selectedHouses[index] || false} onChange={() => handleCheckboxChange(index)} />
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="row mt-4 mb-4">
                        <div className="btns mt-3 d-flex justify-content-end gap-3 mx-auto" style={{ maxWidth: "900px", width: "100%" }}>
                          <button className="btnn" onClick={handleFacturar}>Facturar</button>
                        </div>
                        {facturarError && <div className="text-danger mt-2 alert alert-danger text-center">Debe de seleccionar al menos una house</div>}
                      </div>
                    </>
                  )}

                  {showPartialTable && (
                    <table className="table text-center mx-auto" style={{ maxWidth: "900px", width: "100%" }}>
                      <thead className="table fondo-head">
                        <tr>
                          {pastInvoices.some(item => item.hbs !== "-") && <th>House</th>}
                          <th>Pedimentosssssss</th><th>Folio</th><th>Fecha</th><th>Piezas</th><th>Peso</th><th>Total</th><th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pastInvoices.map((val, index) => (
                          <tr key={index}>
                            {pastInvoices.some(item => item.hbs !== "-") && <td>{val.hbs ?? "-"}</td>}
                            <td>{val.pediment ?? "-"}</td><td>{val.folio}</td><td>{formatDate(val.date)}</td>
                            <td>{addCommas(val.pieces)}</td><td>{addCommas(val.weight)}</td><td>${addCommas(val.total)}</td>
                            <td><FaInfo style={{ cursor: "pointer" }} onClick={() => handleShowInvoiceDetails(val.id)} /></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default BillingSearch;